import { render, staticRenderFns } from "./enclosure-list.vue?vue&type=template&id=a5887d18&scoped=true&"
import script from "./enclosure-list.vue?vue&type=script&lang=js&"
export * from "./enclosure-list.vue?vue&type=script&lang=js&"
import style0 from "./enclosure-list.vue?vue&type=style&index=0&id=a5887d18&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5887d18",
  null
  
)

export default component.exports